/* eslint-disable no-inline-comments */
import type {
	BreakpointsOptions,
} from '@mui/material'

export const materialUIBreakpointsTheme: BreakpointsOptions = {
	values: {
		zero: 0,
		xs:   30,       // 480
		xxs:  40,       // 640
		sm:   47.99875, // 767.98
		md:   61.99875, // 991.98
		mmd:  77.5, 	// 1240
		lg:   92.5,     // 1480
		xl:   100,      // 1600
	},
	unit: 'rem',
}
